import { LanguageMap } from "@/assets/languages/language";

export const fin: LanguageMap = {
  enterId: "Syötä koodi",
  rotationList: "Suoritusjärjestys",
  headJudgeCalledMeeting: "Ylituomari kutsuu palaveriin",
  pointsAcceptedByHeadJudge: "Ylituomari hyväksyi pisteet",
  waitingHeadJudgeAcceptance: "Odotetaan ylituomarin hyväksyntää",
  moveToNextParticipant: "Pisteet hyväksytty. Siirrytäänkö seuraavaan kilpailijaan?",
  penaltyAndBonus: "Vahvista ja bonus",
  resultsOfTheCompetition: "Wait for the results of the competition",
  confirmPenaltyAndBonus: "Vahvista vähennykset ja bonus",
  confirmPenalty: "Vahvista vähennykset",
  confirmBonus: "Vahvista bonus",
  current: "Esintyy nyt",
  next: "Seuraava",
  total: "Yht.",
  authInformation: "Kirjautumistiedot",
  competition: "Kilpailu",
  date: "Päivämäärä",
  elements: "VAIKEUSOSAT",
  searchPlaceholder: "Etsi…",
  value: "Kohta",
  ratingMultipleInputs: {
    selectCellToEnter: "Valitse ruutu syöttääksesi pisteet",
    selectCellToView: "Valitse ruutu nähdäksesi arviointikohteen",
    labelWithMax: "{label} (max {max})",
  },
  numpad: "Numpad",
  noPenalty: "Ei vähennyksiä",
  buttons: {
    logIn: "Kirjaudu sisään",
    cancel: "Peruuta",
    send: "Lähetä",
    back: "Takaisin",
    callMeeting: "Kutsu palaveri",
    done: "Valmis",
    bonus: "Bonus",
    penalty: "Vähennys",
    confirm: "Vahvista",
    confirmSending: "Vahvista pisteiden lähetys",
    confirmSendingFeedback: "Vahvista palautteen lähetys",
    changeOwnPoints: "Korjaa pisteet",
    logOut: "Kirjaudu ulos",
    yes: "Kyllä",
    no: "Ei",
    ok: "Hyväksy",
    saveOwnPoints: "Tallenna omat pisteet",
    continue: "Jatka",
    hideAddInteface: "Piilota lisätoiminnot",
    showAddInteface: "Näytä lisätoiminnot",
    saveDraft: "Tallenna luonnos",
    select: "Valitse",
  },
  error: {
    incorrectCode: "Väärä koodi",
    warningTitle: "Varoitus",
    networkError: "Tarkista verkkoyheys",
  },
  agg_tv_element_group: {
    combined_series: "Kahden liikesuvun yhdistelmät",
    combined_series_short: "Yhdistelmät",
    balances: "Tasapainot",
    jumps: "Hypyt",
    total_bm: "Vartalon liikkeet",
    tbm: "Yksittäiset vartaloliikkeet",
    bms: "Vartalosarjat",
    dance_step_series: "Askel- ja hyppelysarjat",
    step_series: "Askelsarjat",
    acrobatics: "Akrobatialiikkeet",
    flexibility: "Liikkuvuusliikkeet",
    bilaterality: "Liikkuvuusliikkeet 135°",
    bilaterality_adults: "Molemminpuoleisuus",
    body_series: "3 korkeinta vartalosarjaa",
  },
  agg_avb_element_group: {
    bilaterality: "Molemminpuolisuus",
    bms_criteria: "Vartalosarjat",
    additional_allowances: "Lisäosat",
    collaboration_elements: "Yhteistyöelementit",
    originality: "Omaperäisyys",
  },
  agg_avb_element: {
    bilaterality_balance_right: "Tasapaino – oikea",
    bilaterality_balance_left: "Tasapaino – vasen",
    bilaterality_jump_right: "Hyppy – oikea",
    bilaterality_jump_left: "Hyppy – vasen",
    bms_turning: "Suunnanvaihto, käännös/pyörähdys",
    bms_level_change: "Tason vaihto",
    bms_travelling: "Liikkuminen",
    bms_tempo: "Tempon vaihtelu",
    bms_dynamics: "Voimankäytön vaihtelu",
    additional_body_balance: "Tasapaino, joka alkaa suoraan vartalonliikkeestä",
    additional_body_jump: "Hyppy, joka alkaa suoraan vartalonliikkeestä",
    additional_rotating_balance: "Pyörivä tasapaino (piruetti / illuusio)",
    additional_rotating_jump: "Pyörivä / kääntyvä hyppy",
    collaboration_team_collaboration: "Yhteistyöliike ilman nostoa",
    collaboration_duo_trio_collaboration: "Pari-/trio liike noston kanssa tai ilman",
    collaboration_team_lift: "Yhteistyöliike nostolla",
    collaboration_sync_element: "Synkronoitu liikesarja",
    collaboration_canon: "Kaanon",
    originality_movement: "Omaperäisyys liikkeissä",
    originality_collaboration: "Omaperäisyys yhteistyöliikkeissä ja kuvioissa",
    originality_music: "Unohtumaton yhteys musiikin ja koreografian välillä",
    originality_story: "Teemallinen tarina/tyyli",
  },
  feedback: {
    title: "Palaute",
    draftSaved: "Luonnos tallennettu",
    submitReminder: "Muista lähettää palautteesi Lähetä-painikkeella, kun olet valmis",
    feedbackNotSubmitted: "Palautetta ei ole lähetetty",
    field: {
      overallImpression: "Täysosuma - mikä jäi mieleen?",
      gymnastGreetings: "Terveisiä voimistelijoille",
      coachGreetings: "Terveisiä valmentajalle",
    },
  },
  penalty: {
    forbidden_move: "Kielletty liike tai nosto",
    offence: "Uskonnollinen/poliittinen loukkaus",
    insult: "Uskonnollinen/poliittinen loukkaus",
    coming_in: "Joukkueen sisääntulo",
    entrance: "Joukkueen sisääntulo",
    dress: "Puku, hiukset, meikki",
    decoration: "Hiusväristä aiheutunut tahra matolla",
    time: "Ylimääräinen tai puuttuva sekunti",
    wrong_apparatus: "Sääntöjen vastainen väline",
    lost_items: "Pudonnut osa",
    too_few_members: "Puuttuva voimistelija",
    reserved_apparatus: "Varavälineen käyttöönotto",
    too_many_apparatus: "Ylimääräinen varaväline rajalla tai alueella",
    replacement_apparatus_assistance: "Avustajan käyttö varavälineen käyttöönotossa",
    assistance: "Joukkueen avustaminen",
    border: "Rajan ylitys",
    extra_sound: "Ylimääräiset äänet",
    team_assistance: "Joukkueen avustaminen",
    athlete_or_coach_behavior: "Voimistelijan/valmentajan toiminta",
  },
  agg_tv_element: {
    combined_series_bms_balance: "Vartalosarja + tasapaino",
    combined_series_bms_jump: "Vartalosarja + hyppy",
    combined_series_balance_bms: "Tasapaino + vartalosarja",
    combined_series_bbms_or_bmsb: "TP+V / V+TP",
    combined_series_jump_bms: "Hyppy + vartalosarja",
    combined_series_jbms_or_bmsj: "H+V / V+H",
    combined_series_jump_balance: "Hyppy + tasapaino",
    combined_series_jb_or_bj: "TP+H / H+TP",
    combined_series_balance_jump: "Tasapaino + hyppy",
    combined_series_jump_balance_bms: "H/TP+Vartalot / Vartalot+H/TP",
    balances_double_balance: "Tasapainosarja",
    balances_single_balance: "Tasapaino",
    balances_balance: "Tasapaino",
    balances_dyn_balance: "Dynaaminen tasapaino",
    balances_balance_series: "Tasapainosarja",
    jumps_double_jump: "Hyppysarja",
    jumps_single_jump: "Hyppy",
    jumps_jump: "Hyppy",
    jumps_rotation_jump: "Kääntyvä/pyörivä hyppy",
    jumps_jump_series: "Hyppysarja",
    bms_bms1: "Vartalosarja 1",
    bms_bms_1: "Vartalosarja 1",
    bms_bms2: "Vartalosarja 2",
    bms_bms_2: "Vartalosarja 2",
    bms_bms3: "Vartalosarja 3",
    bms_bms_3: "Vartalosarja 3",
    bms_bms4: "Vartalosarja 4",
    bms_bms_4: "Vartalosarja 4",
    bms_bms5: "Vartalosarja 5",
    tbm_wave1: "Aalto",
    tbm_wave_1: "Aalto",
    tbm_wave2: "Aalto",
    tbm_wave_2: "Aalto",
    tbm_swing1: "Vauhtiheitto",
    tbm_swing_1: "Vauhtiheitto",
    tbm_swing2: "Vauhtiheitto",
    tbm_swing_2: "Vauhtiheitto",
    total_bm_wave: "Aalto",
    total_bm_swing: "Vauhtiheitto",
    total_bm_twisting: "Kierto",
    total_bm_contraction: "Koonto",
    total_bm_relaxation: "Pystyrentous",
    total_bm_lunge_lean: "Syöksy tai kallistus",
    total_bm_series_a: "A-vartalosarja",
    total_bm_series_b: "B-vartalosarja",
    total_bm_series_c: "C-vartalosarja",
    total_bm_total_wave: "Totaali aalto",
    total_bm_total_swing: "Totaali vauhtiheitto",
    dance_step_series_combined: "Askelsarja yhdistettynä muuhun liikesukuun",
    dance_step_series_dss_1: "Askelsarja, sis. suunnanvaihto ja käännös",
    dance_step_series_dss_2: "Askelsarja, sis. liikkumisen, suunnanvaihdon JA 360° käännöksen",
    dance_step_series_dss_3: "Askelsarja, sis. liikkumisen, suunnanvaihdon TAI 360° käännöksen",
    dance_step_series_dss_4: "Askelsarja, sis. rytminvaihdon TAI yhdistämisen muuhun liikesukuun",
    step_series_plus_other: "Askelsarja yhdistettynä muuhun liikesukuun",
    acrobatics_acro_move: "Akrobatialiike",
    flexibility_back: "Liikkuvuus ranka",
    flexibility_side_line: "Liikkuvuus sivulinja",
    flexibility_right: "Liikkuvuus oikea",
    flexibility_left: "Liikkuvuus vasen",
    flexibility_additional: "Valinnainen liikkuvuusliike (oikea / vasen / sivu / ranka)",
    bilaterality_balance_left: "Tasapaino vasen",
    bilaterality_balance_right: "Tasapaino oikea",
    bilaterality_jump_left: "Hyppy vasen",
    bilaterality_jump_right: "Hyppy oikea",
    body_series_1: "1. vartalosarja",
    body_series_2: "2. vartalosarja",
    body_series_3: "3. vartalosarja",
  },
  stara: {
    group: {
      body_control: "Kehonhallinta",
      physical_qualities: "Fyysiset ominaisuudet",
      sport_skills: "Lajitaito",
      presentation: "Esiintyminen",
      group_assessment: "Ryhmäarviointi",
    },
    element: {
      posture: "Ryhti",
      balance: "Tasapainokyky",
      agility: "Ketteryys",
      core: "Keskivartalo",
      basic_positions: "Perusasennot",
      extensions: "Ojennukset",
      flexibility: "Liikkuvuus",
      strength: "Voima",
      speed: "Nopeus",
      endurance: "Kestävyys",
      technique: "Tekniikka",
      movement_skills: "Liikkumistaidot",
      rhythm_tempo: "Rytmi ja tempo",
      joy_enthusiasm: "Ilo ja innokkuus",
      expression: "Eläytyminen",
      memory: "Muistaminen",
      courage: "Rohkeus",
      simultaneity_rhythm: "Yhtäaikaisuus / rytmi",
      uniform_technique: "Yhtenevä suoritustekniikka",
      group_cooperation: "Ryhmän yhteistyö",
      patterns_formations: "Kuviot ja muodostelmat",
      group_contact: "Ryhmän sisäinen kontakti",
    },
    grade: {
      A: "WOW",
      B: "Hyvä",
      C: "Harjoittele",
    },
  },
  dance: {
    T1: {
      perf_presence: "Läsnäolo",
      perf_energy: "Energia",
      perf_fluency: "Sujuvuus",
      perf_naturalness: "Luontevuus",
      perf_interaction: "Vuorovaikutus tanssijoiden ja/tai yleisön ja olosuhteiden kanssa",
      expr_consistency: "Ilmaisu kantaa läpi koreografian",
      expr_alignment: "Ilmaisu sopii koreografiaan",
      expr_interpretation:
        "Ikä- ja taitotasolle sopiva kehollinen liikkeen ja koreografian tulkinta",
      expr_impact: "Koreografia koskettaa/puhuttelee",
      overall_value: "Teoksen kokonaisuus",
    },
    T2: {
      tech_mastery: "Valitun tanssityylin ominaisen tekniikan hallitseminen",
      tech_authenticity:
        "Teoksessa käytetyn tanssitekniikan ja -kulttuurin toteutuminen ja soveltaminen",
      tech_precision: "Tarkkuus, hyvin harjoiteltu, yhdenaikainen, hiottu, varma suoritus",
      tech_dynamics: "Dynamiikan soveltaminen",
      tech_timing: "Rytmiikka, yhteistyö, ajoitus",
      tech_flow: "Hengitys ja virtaavuus",
      phys_control: "Kehonhallinta",
      phys_agility: "Ketteryys",
      phys_strength: "Voima",
      phys_balance: "Tasapaino",
      phys_flexibility: "Liikkuvuus",
      phys_endurance: "Kestävyys",
      safety_value: "Turvallisuus (nostot, hypyt, akrobatia, kehonhallinta)",
      overall_value: "Teoksen kokonaisuus",
    },
    T3: {
      chor_creativity: "Luovuus ja omaperäisyys",
      chor_appropriateness: "Koreografian ja teeman eettisyys ja sopivuus ikä- ja taitotasolle",
      chor_music: "Musiikin sopivuus ikä- ja taitotasolle",
      chor_styling: "Asut, meikit ja rekvisiitta on suunniteltu kokonaisuudeksi teeman mukaan",
      chor_continuity: "Liikkeiden ja liikesarjojen yhdistäminen kokonaisuudeksi",
      chor_suitability:
        "Liikevalintojen sopivuus ryhmän taitotasolle ja ryhmän fyysisille ominaisuuksille",
      chor_interpretation: "Liikevalinnat suhteessa valittuun teemaan",
      chor_spacing: "Esiintymisalueen käyttö, kuviot, tasot, suunnat ja siirtymiset",
      chor_musicality: "Musiikin hyödyntäminen koreografiassa",
      chor_overall: "Teoksen kokonaisuus",
    },
    T: {
      idea_creativity: "Luovuus ja omaperäisyys",
      idea_ethics: "Koreografian ja teeman eettisyys ja sopivuus ikä- ja taitotasolle",
      idea_music: "Musiikin sopivuus ikä- ja taitotasolle",
      idea_costumes: "Asut, meikit ja rekvisiitta on suunniteltu kokonaisuudeksi teeman mukaan",
      comp_combination: "Liikkeiden ja liikesarjojen yhdistäminen kokonaisuudeksi",
      comp_suitability:
        "Liikevalintojen sopivuus ryhmän taitotasolle ja ryhmän fyysisille ominaisuuksille",
      comp_theme: "Liikevalinnat suhteessa valittuun teemaan",
      comp_space: "Esiintymisalueen käyttö, kuviot, tasot, suunnat ja siirtymiset",
      comp_music: "Musiikin hyödyntäminen koreografiassa",
      overall_unity: "Teoksen kokonaisuus",
    },
  },
  gfl: {
    T: {
      value1: "Ilmaisullisuus",
      value2: "Innovaatio ja omaperäisyys",
      value3: "Tekniikka, laatu, turvallisuus",
      value4: "Kokonaisuus, vaihtelevuus ja monimuotoisuus",
    },
    feedbackTitle: "Vahvuudet ja vinkit harjoitteluun",
  },
  tanvo: {
    T: {
      basic_technique: "Tanssillisen voimistelun perustekniikan osaaminen",
      chor_variety: "Koreografian monimuotoisuus / monipuolisuus",
      exe_confidence: "Suorituksen varmuus ja yhtenäisyys",
      music_use: "Musiikin käyttö ja sen sopivuus valittuihin liikkeisiin",
      area_use: "Esiintymisalueen käyttö",
      safety: "Turvallisuus ja voimistelijoiden fyysisten ominaisuuksien riittävyys",
      value1: "Kohta 1",
      value2: "Kohta 2",
      value3: "Kohta 3",
      value4: "Kohta 4",
      value5: "Kohta 5",
      value6: "Kohta 6",
    },
    CHOR: {
      chor_structure: "Koreografian rakenne",
      chor_music: "Liikemateriaalin yhdistäminen musiikkiin, musiikin käyttö",
      chor_movement_language: "Liikekielen sopivuus koreografiaan",
      chor_dynamics:
        "Dynamiikan ja tempon vaihtelut tanssillisen voimistelun liikkeissä ja liikesarjoissa",
      chor_space: "Esiintymisalueen käyttö, kuviot, tasot, suunnat ja siirtymiset",
      chor_difficulty:
        "Tanssillisen voimistelun liikkeiden vaikeusasteen ja koreografian soveltuminen joukkueelle",
      chor_originality: "Koreografian elämyksellisyys, omaperäisyys ja kekseliäisyys",
      chor_interaction: "Vuorovaikutuksen toimivuus",
      chor_overall: "Koreografian kokonaisuus",
      value1: "Kohta 1",
      value2: "Kohta 2",
      value3: "Kohta 3",
      value4: "Kohta 4",
      value5: "Kohta 5",
      value6: "Kohta 6",
      value7: "Kohta 7",
      value8: "Kohta 8",
      value9: "Kohta 9",
    },
    EXE: {
      exe_core_movement:
        "Tanssilliselle voimistelulle ominaisen keskustalähtöisen liikunnan oikea toteuttaminen",
      exe_precision: "Hyvin harjoiteltu, hiottu, varma suoritus",
      exe_body_movements: "Tanssillisen voimistelun vartaloliikkeiden hallinta",
      exe_posture: "Kehon kannatus ja ryhti",
      exe_foot_technique: "Jalkatekniikka",
      exe_arm_technique: "Käsiliikkeiden hallinta tanssillisen voimistelun tekniikkaa hyödyntäen",
      exe_formations: "Kuvioiden muodostuminen",
      exe_safety: "Turvallisuus ja voimistelijoiden fyysisten ominaisuuksien riittävyys",
      exe_performance: "Esiintyminen ja ilmaisu",
      value1: "Kohta 1",
      value2: "Kohta 2",
      value3: "Kohta 3",
      value4: "Kohta 4",
      value5: "Kohta 5",
      value6: "Kohta 6",
      value7: "Kohta 7",
      value8: "Kohta 8",
      value9: "Kohta 9",
    },
  },
};
